<template>
  <div>
    <data-table :service="service"
                :entity="entity"
                :filters="filters"
                :disable-permission-checks="true"
                :columns="columns"
                operations="refresh,delete"
                ref="table">
      <template v-slot:created_at="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
      <template v-slot:file_uuid="{row}">
        <tooltip-icon-button type="primary"
                             v-if="row.file_uuid"
                             :content="$t('generic.download')"
                             icon="nc-icon nc-cloud-download-93"
                             @click.stop="downloadCV(row)">
        </tooltip-icon-button>
        <div v-else>
          {{$t('generic.na')}}
        </div>
      </template>
      <template v-slot:open_to_relocate="{row}">
        <status-badge :status="row.open_to_relocate ? 'yes': 'no'"/>
      </template>
      <template v-slot:status="{row}">
        <status-badge :status="row.status || 'N/A'"/>
      </template>
    </data-table>
  </div>
</template>
<script>
  import entities from 'src/config/entities'
  import FileService from 'src/services/FileService'
  import ResumeService from 'src/services/ResumeService'
  import TooltipIconButton from 'src/components/Buttons/TooltipIconButton'
  import TextOverflowTooltip from 'src/components/TextOverflowTooltip'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'resume-list',
    components: {
      TooltipIconButton,
      TextOverflowTooltip
    },
    props: {
      jobId: String,
      filters: {
        type: Array,
        default: () => [
          {
            key: 'with',
            value: 'candidate,candidate.user,job'
          },
          {
            key: 'sort',
            value: '+created_at'
          }
        ]
      }
    },
    data () {
      return {
        FRIENDLY_DATETIME_FORMAT,
        entity: entities.RESUME
      }
    },
    computed: {
      service () {
        return ResumeService
      },
      columns () {
        return [
          {
            prop: 'address',
            label: this.$t('generic.address'),
            minWidth: '200px',
            sortable: true
          },
          {
            prop: 'country',
            label: this.$t('generic.country'),
            minWidth: '140px',
            sortable: true
          },
          {
            prop: 'city',
            label: this.$t('generic.city'),
            minWidth: '130px',
            sortable: true
          },
          {
            prop: 'phone_number',
            label: this.$t('generic.phone'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'open_to_relocate',
            label: this.$t('resume.open_to_relocate'),
            minWidth: '180px',
            sortable: true
          },
          {
            prop: 'status',
            label: this.$t('generic.status'),
            minWidth: '100px',
            sortable: true
          },
          {
            prop: 'file_uuid',
            label: this.$t('resume.cv'),
            minWidth: '80px',
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '160px',
            sortable: true
          }
        ]
      }
    },
    methods: {
      async downloadCV (row) {
        try {
          const date = this.$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)
          let name = `CV-${date}`
          this.$set(row, 'loading', true)
          await FileService.downloadFile(row.file_token, name)
        } catch (e) {
          this.$notify({
            type: 'danger',
            message: this.$t('resume.download.error')
          })
        } finally {
          this.$set(resume, 'loading', false)
        }
      }
    }
  }
</script>
<style>
</style>
